import { Alert } from "@jugl-web/ui-components/cross-platform/Alert";
import {
  useTranslations,
  convertSnakeCaseToReadableString,
  getImagePathForSharedLibrary,
} from "@jugl-web/utils";
import { ReactComponent as EyeIcon } from "./assets/eye.svg";
import alertImg from "./assets/visibility-alert.jpg";

export const CustomerFieldVisibilityConfirmAlert = ({
  isOpen,
  fieldName,
  onClose,
  onConfirm,
}: {
  isOpen: boolean;
  fieldName: string;
  onClose: () => void;
  onConfirm: () => void;
}) => {
  const { t } = useTranslations();
  const imgSrc = getImagePathForSharedLibrary(alertImg);

  return (
    <Alert
      isOpen={isOpen}
      className="w-[760px] max-w-[90vw] "
      imgContainerClassName="[&>img]:w-[600px]"
      onRequestClose={onClose}
      isCloseButtonVisible
      header={
        <div className="flex gap-3">
          <EyeIcon />
          {t({
            id: "customer-page.field-visibility-confirm-alert-title",
            defaultMessage: "Attribute Visibility",
          })}
        </div>
      }
      title={t({
        id: "customer-page.field-visibility-confirm-alert-title",
        defaultMessage: "Confirm Customer Attribute Visibility",
      })}
      img={imgSrc}
      content={
        <div className="flex w-full justify-center">
          <div className="max-w-[500px]">
            {t(
              {
                id: "customer-page.field-visibility-confirm-alert-content",
                defaultMessage:
                  "Are you sure you want to make update attribute {fieldName} visible only for Admins of the Workspace?",
              },
              {
                fieldName: (
                  <span className="text-primary font-medium capitalize">
                    {convertSnakeCaseToReadableString(fieldName)}
                  </span>
                ),
              }
            )}
          </div>
        </div>
      }
      buttonsContainerClassName="flex justify-center [&>button]:flex-none"
      buttons={[
        {
          text: t({ id: "common.cancel", defaultMessage: "Cancel" }),
          role: "close",
          className:
            "font-normal font-secondary font-medium text-dark-700 w-[180px] h-10",
        },
        {
          text: t({
            id: "common.confirm",
            defaultMessage: "Confirm",
          }),
          className: "font-normal font-secondary font-medium w-[200px] h-10",
          color: "primary",
          onClick: (_, actions) => {
            onClose();
            actions.closeAlert();
            onConfirm();
          },
        },
      ]}
    />
  );
};
